import { atom } from 'jotai';

import { type MessagingRequest } from '@frontend/constants';

export const opalOverlayOpenAtom = atom(false);

/**
 * Initial messaging state applied the next time the overlay opens — e.g. "Ask Opal"
 * sets `{ mode: 'ai-chat' }` so the panel lands on the Opal chat tab (whose body
 * drains + sends the queued prompt) instead of restoring team messages. Undefined =
 * the overlay keeps its own last state. Cleared by the overlay on close.
 */
export const opalOverlayInitialMessagingAtom = atom<MessagingRequest | undefined>(undefined);

/**
 * Whether the federated chat body is currently mounted and has signalled ready (its
 * SET_THREAD listener exists). Owned by OpalChatOverlay — the only place that knows the
 * body's mount gate — so consumers (Ask Opal) can't desync: the body unmounts on auth/
 * user loss or a `/chat` route even while `opalOverlayOpenAtom` stays true, and this
 * atom follows that, whereas the open atom alone does not.
 */
export const chatBodyReadyAtom = atom(false);
